import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../components/PageWrapper';
import HeroSection from '../components/HeroSection';
import SEO from '../components/SEO';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUsers, FiBriefcase, FiCheckCircle, FiArrowRight } = FiIcons;

const Home = () => {
  return (
    <PageWrapper>
      <SEO 
        title="Startseite" 
        description="Willkommen bei Nordblick Recruiting. Wir sind Ihre private Arbeitsvermittlung in Hamburg für Jobs und professionelle Personallösungen." 
      />
      
      <HeroSection 
        title="Wir finden den Job, der zu Ihnen passt" 
        subtitle="Professionelle Arbeitsvermittlung – persönlich, direkt und ohne Umwege."
        bgImage="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1920&q=80"
        cta1={{ text: 'Jobs finden', link: '/jobs' }}
        cta2={{ text: 'Personal anfragen', link: '/unternehmen' }}
      />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            
            {/* Bewerber Box */}
            <div className="bg-slate-50 p-10 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-14 h-14 bg-cyan-100 rounded-xl flex items-center justify-center mb-6">
                <SafeIcon icon={FiUsers} className="h-7 w-7 text-cyan-600" />
              </div>
              <h2 className="text-3xl font-bold text-blue-900 mb-4">Für Bewerber</h2>
              <p className="text-slate-600 mb-8 leading-relaxed">
                Auf der Suche nach neuen Herausforderungen? Wir öffnen Türen zu Top-Unternehmen, beraten auf Augenhöhe und finden den Job, der wirklich zu dir passt.
              </p>
              <ul className="space-y-3 mb-8">
                {['Vertrauliche Behandlung der Daten', 'Persönliche Beratung', 'Zugang zu verdeckten Stellen'].map((item, i) => (
                  <li key={i} className="flex items-center text-slate-700">
                    <SafeIcon icon={FiCheckCircle} className="h-5 w-5 text-cyan-500 mr-3" />
                    {item}
                  </li>
                ))}
              </ul>
              <Link to="/bewerber" className="text-blue-900 font-semibold hover:text-cyan-600 flex items-center gap-2">
                Jetzt bewerben <SafeIcon icon={FiArrowRight} />
              </Link>
            </div>

            {/* Arbeitgeber Box */}
            <div className="bg-blue-900 p-10 rounded-2xl text-white shadow-lg relative overflow-hidden">
              <div className="absolute top-0 right-0 -mt-10 -mr-10 opacity-10">
                <SafeIcon icon={FiBriefcase} className="h-64 w-64" />
              </div>
              <div className="relative z-10">
                <div className="w-14 h-14 bg-blue-800 rounded-xl flex items-center justify-center mb-6">
                  <SafeIcon icon={FiBriefcase} className="h-7 w-7 text-cyan-400" />
                </div>
                <h2 className="text-3xl font-bold mb-4">Für Arbeitgeber</h2>
                <p className="text-blue-100 mb-8 leading-relaxed">
                  Fachkräftemangel? Nicht mit uns. Wir bieten maßgeschneiderte Personallösungen – von der klassischen Personalvermittlung bis zur Unterstützung bei internationalen Fachkräften.
                </p>
                <ul className="space-y-3 mb-8">
                  {['Passgenaue Profile', 'Internationale Fachkräfte', 'Volle Flexibilität'].map((item, i) => (
                    <li key={i} className="flex items-center text-blue-50">
                      <SafeIcon icon={FiCheckCircle} className="h-5 w-5 text-cyan-400 mr-3" />
                      {item}
                    </li>
                  ))}
                </ul>
                <Link to="/unternehmen" className="text-cyan-400 font-semibold hover:text-white flex items-center gap-2">
                  Personal anfragen <SafeIcon icon={FiArrowRight} />
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>

    </PageWrapper>
  );
};

export default Home;